import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import appSettings from '../../../appSettings';

const REQUIRED_ROLE = appSettings.USER_GROUP;

const PermissionRequiredComponent = ({
  open,
  onLogout
}) => (
  <Dialog
    open={open}
    disableEscapeKeyDown
    onClose={(event, reason) => {
      if (reason !== 'backdropClick') {
        return;
      }
    }}
  >
    <DialogTitle>Permission Required</DialogTitle>

    <DialogContent>
      You do not have permission to access Alert Management.
    </DialogContent>
    <DialogContent>
      Please submit an IAM request for the user group {REQUIRED_ROLE} to gain access
    </DialogContent>
    <DialogActions>
      <Button color="primary" variant="contained" onClick={onLogout}>
        Log Out
      </Button>
    </DialogActions>
  </Dialog>
);

export default PermissionRequiredComponent;